import lodashMerge from 'lodash.merge'

export function merge(into: any, from: any) {
  return lodashMerge({}, into, from)
}



// WEBPACK FOOTER //
// ../../src/utils.ts